import { Record } from 'immutable';

import {
  UPDATE_SIDEBAR,
} from './actions';

export const Metadata = new Record({
  betslipTab: 'betslip' // ['betslip', 'active-bets', 'bet-builder']
});

const InitialState = new Record({
  visible: false,
  content: 'betslip',
  metadata: new Metadata(),
});

export const initialState = new InitialState();

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_SIDEBAR: {
      const {
        visible = true,
        content = '',
        metadata = {}
      } = payload;

      return state
        .set('visible', visible)
        .set('content', content)
        .set('metadata', new Metadata(metadata));
    }
    default:
      return state;
  }
};
